<template>
<div>
	
	<profile-overview :viewing_user_id="viewing_user_id" viewing_type="member_dashboard" />

</div>
</template>


<script>
import ProfileOverview from '../components/ProfileOverview.vue';

export default {
	name: "ProfileOverviewDashboard",
	components:{ 
		ProfileOverview,
	},
	props: {
	},
	data() {
		return {
		}
	},
	computed:{
		viewing_user_id(){
			var id = 0;
			if(this.$route.params.user_id){
				id = this.$route.params.user_id;
			}
			return id;
		}
	},
	methods:{		
	},
	mounted() {
	},
	watch: {
	},
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
